import { Component } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import {
  ApplicationHostTypeService,
  ReferenceDataCategoriesConstants,
  ReferenceDataConstants,
  ReferenceDataLabels,
  ReferenceDataOptionLists,
  ReferenceDataService,
  RomeNotificationService,
  StatusResponse,
  ValidationErrors
} from 'rome-library';
import { UserCredentialStore } from '../../../interfaceTypes/sharedFeatures/registration/services';
import { States } from '../../../shared';
import { ExternalUserResetPasswordDto } from '../../models/external-user-reset-password-dto.model';
import { UserService } from '../../services/user.service';

@UntilDestroy()
@Component({
  selector: 'boi-expired-password',
  templateUrl: './expired-password.page.html'
})
export class ExpiredPasswordPage {
  public resetPasswordDto = new ExternalUserResetPasswordDto();
  public readonly referenceDataLabels = ReferenceDataLabels;
  public readonly referenceDataOptionLists = ReferenceDataOptionLists;
  public readonly referenceDataConstants = ReferenceDataConstants;
  public readonly referenceDataCategoriesConstants = ReferenceDataCategoriesConstants;
  public errorMessage: string;
  public validationErrors: ValidationErrors;

  constructor(
    private readonly userService: UserService,
    private readonly notificationService: RomeNotificationService,
    private readonly referenceDataService: ReferenceDataService,
    private readonly userCredentialStore: UserCredentialStore,
    private readonly router: Router,
    private readonly applicationHostTypeService: ApplicationHostTypeService
  ) {}

  public changeExpiredPassword(form: NgForm): void {
    if (form.valid) {
      this.resetPasswordDto.OldPassword = this.userCredentialStore.getExpiredPassword();
      this.resetPasswordDto.EmailAddress = this.userCredentialStore.getEmail();
      if (
        this.resetPasswordDto.NewPassword === this.resetPasswordDto.ConfirmedNewPassword &&
        this.resetPasswordDto.OldPassword &&
        this.resetPasswordDto.EmailAddress
      ) {
        this.userService
          .resetPassword(this.resetPasswordDto)
          .pipe(untilDestroyed(this))
          .subscribe(
            (response) => {
              this.handleResponse(response);
            },
            (errorResponse) => {
              this.errorMessage = errorResponse.error.Message;
            }
          );
      }
    } else {
      form.control.markAllAsTouched();
    }
  }

  private handleResponse(response: StatusResponse): void {
    this.validationErrors = new ValidationErrors(response.ValidationErrors);

    if (response.Status === this.referenceDataOptionLists.UserRegistrationStatusSuccessful) {
      const message = this.referenceDataService.getLocalizeLabel(this.referenceDataLabels.NotificationSaveSuccess);
      this.notificationService.showInfo(message);

      this.userCredentialStore.setExpiredPassword(undefined);
      this.goToLogin();
    }
  }

  public goBack(): void {
    this.goToLogin();
  }

  private goToLogin(): void {
    void this.router.navigate([this.applicationHostTypeService.getCode(), States.Login]);
  }

  public setErrorMessageByDescription(errorDescription: string): void {
    const errorValue = this.referenceDataService.getConfigurationValueByCode(
      this.referenceDataCategoriesConstants.ERROR_MESSAGE,
      this.referenceDataConstants.ERROR_MESSAGE_USER_ACCOUNT,
      errorDescription
    );

    if (errorValue) {
      this.errorMessage = errorValue;
    }
  }
}
